<script lang="ts" setup>
import { useCloudType } from '@/composables/useCloudType';

const { appName } = defineProps<{ appName: string }>();

const el = ref<HTMLElement | null>(null);
const { cloudName } = useCloudType(el);
</script>

<template>
  <h2 class="launch-cloud-name" ref="el">Launch {{ appName }} with Clovyr on {{ cloudName }}</h2>
</template>

<style scoped lang="scss">
@use '@clovyr/bed/styles/vendor/bootstrap/scss/bootstrap';
@use '@clovyr/bed/styles/core';
@use 'src/styles/core/page';
@use 'src/styles/core/vertical-spacing';
@use 'styles/core/colors';
@use 'styles/core/typography/fonts';
@use 'styles/vendor/bootstrap/scss/mixins/breakpoints';

.launch-cloud-name {
  @include fonts.font-size(22);

  color: colors.color(grey, tertiary);
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: -0.03rem;

  @include breakpoints.media-breakpoint-up(md) {
    @include fonts.font-size(24);

    font-weight: 400;
  }

  @include breakpoints.media-breakpoint-up(xl) {
    @include fonts.font-size(30);
  }
  @include breakpoints.media-breakpoint-up(xxl) {
    @include fonts.font-size(38);
  }
}
</style>
